import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh";

import accountService from "../../services/accountsService";

//actions
import * as dialogActions from "../../redux/actions/dialogactions";

//containers
import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";

//components
import UserAccount from "./UserAccountx";

class Accounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      fetching: true,
      failed: false,
      selectedRow: null,
      data: [],
      anchorEl: null,
      openMenu: false,
      filterstate: "",
      orderBy: "email",
      order: "asc",
      tabValue: 0,
      userType: "User"
    };
    this.closeDialog = this.closeDialog.bind(this);
    this.getAccounts = this.getAccounts.bind(this);
  }

  async componentDidMount() {
    // this.getAccounts();
  }

  async getAccounts() {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let body = await accountService.getAccounts();
      this.setState({
        data: body,
        fetching: false,
        failed: false
      });
    } catch (err) {
      console.log(err.code);
      this.setState({ fetching: false, failed: true });
    }
  }

  openDialog = userType => {
    this.setState({
      open: true,
      userType
    });
  };

  closeDialog(fetch) {
    this.setState({
      open: false,
      fetching: fetch
    });
    if (fetch) {
      this.getAccounts();
    }
  }
  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };
  desc = (a, b, orderBy) => {
    if (b[orderBy].toUpperCase() < a[orderBy].toUpperCase()) {
      return -1;
    }
    if (b[orderBy].toUpperCase() > a[orderBy].toUpperCase()) {
      return 1;
    }
    return 0;
  };

  handleChangeFilter = e => {
    console.log("filter", e.target.value);
    this.setState({
      filterstate: e.target.value
    });
  };
  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  handleChange = (event, tabValue) => {
    this.setState({ tabValue });
  };

  getContent = index => {
    let contents = [
      <UserAccount type="User" key="User" openDialog={this.openDialog} />,
      <UserAccount type="Admin" key="Admin" openDialog={this.openDialog} />
    ];
    return contents[index];
  };

  render() {
    const { data, filterstate, order, orderBy } = this.state;
    const sortData = [];
    data.map(a => {
      a.Attributes.Enabled = a.Enabled;
      a.Attributes.UserStatus = a.UserStatus;
      if (a.Attributes.given_name == undefined || a.Attributes.family_name == undefined) {
        a.Attributes.given_name = "N";
        a.Attributes.family_name = "A";
      }
      sortData.push(a.Attributes);
    });
    let queryData = this.stableSort(sortData, this.getSorting(order, orderBy));
    const accountList = queryData
      .filter(e => e.role.includes(filterstate))
      .map((item, index) => {
        return (
          <TableBody key={index}>
            <TableRow>
              <TableCell>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline",
                      float: "left"
                    }}
                  >
                    <Avatar
                      style={{
                        height: 36,
                        width: 36,
                        fontSize: "0.9rem",
                        fontWeight: "bold",
                        color: "rgb(39, 174, 96)",
                        backgroundColor: "rgb(39, 174, 96,0.1)"
                      }}
                    >
                      {item.given_name && item.family_name && item.given_name[0].toUpperCase() + item.family_name[0].toUpperCase()}
                    </Avatar>
                    <div
                      style={{
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        width: 13,
                        height: 13,
                        background: "rgb(39, 174, 96)",
                        border: "2px solid #fff",
                        borderRadius: 100
                      }}
                    />
                  </div>
                  {/* <div
                  style={{ display: "inline", float: "left", marginLeft: 10 }}
                >
                  {item.given_name && item.family_name
                    ? `${item.given_name} ${
                        item.family_name
                      }`
                    : "TBD"}
                </div> */}
                  {item.given_name == "N" && item.family_name == "A" ? (
                    <Typography color="textSecondary" style={{ marginLeft: 10, textTransform: "capitalize" }}>
                      <i>{`${item.given_name}/${item.family_name}`}</i>
                    </Typography>
                  ) : (
                    <Typography color="textPrimary" style={{ marginLeft: 10, textTransform: "capitalize" }}>
                      {`${item.given_name} ${item.family_name}`}
                    </Typography>
                  )}
                </div>
              </TableCell>
              <TableCell>{item.email}</TableCell>
              <TableCell>{item.Enabled ? "Enabled" : "Disabled"}</TableCell>
              <TableCell>{item.UserStatus}</TableCell>
              <TableCell>{item.role}</TableCell>
            </TableRow>
          </TableBody>
        );
      });

    const headRows = [
      { id: "given_name", numeric: false, disablePadding: false, label: "Name" },
      { id: "email", numeric: false, disablePadding: false, label: "Email" },
      { id: "", numeric: false, disablePadding: false, label: "Status" },
      { id: "", numeric: false, disablePadding: false, label: "Account Status" },
      { id: "", numeric: false, disablePadding: false, label: "Role" }
    ];

    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Accounts">
          <AppBar position="static" elevation={0}>
            <Tabs value={this.state.tabValue} onChange={this.handleChange} aria-label="simple tabs example">
              <Tab label="Users" />
              <Tab label="Admins" />
            </Tabs>
          </AppBar>
          <div style={{ padding: 25 }}>{this.getContent(this.state.tabValue)}</div>
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}

const mapStateToProps = state => {
  const { confirm } = state.dialog;
  return {
    confirmDialog: confirm.open,
    confirmAction: confirm.action,
    confirmChoice: confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Accounts);
